import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { FunctionComponent, useCallback, useState } from 'react';
import { useMutation, UseMutationResult } from 'react-query';
import { useQuickExit } from '../../modules/datastores/useQuickExit';
import { Http } from '../../modules/prelude/http';
// import NotAvailable from '../NotAvailable';
import logo from './../../../assets/logo.svg';
import { SurvivorsConversationStore } from './../../modules/datastores/useGetSurvivorsConversation';
import { removeCookies } from '../../modules/prelude/constants';

interface IHeaderProps {
  task_sid: string;
  messaging_service_key: string;
  helproom_session_on?: boolean;
  helproom_session_data?: {
    visitor_id: string;
    helproom_id: string;
  };
  helproom_id?: string;
  online_hotline_on?: boolean;
  captcha_token: string;
  webchat_language: string;
}

/***
 * Leave Helproom
 */
export const useLeaveHelproomSession = (): UseMutationResult<string, unknown, { helproom_id: string; visitor_id: string; additionalHeaders: Record<string, string> }, unknown> => {
  return useMutation(async ({ helproom_id, visitor_id, additionalHeaders }) =>
    Http.Request('POST', `/helprooms/api/v1/visitor/helprooms.leave?helproom_id=${helproom_id}&visitor_id=${visitor_id}`, additionalHeaders).then((res: any) => res.data)
  );
};

// const LeaveHelproomButton = lazy(() => import('helprooms/LeaveHelproomButton'));
// const HelproomGroundRules = lazy(() => import('helprooms/HelproomGroundRules'));

const Header: FunctionComponent<IHeaderProps> = ({
  task_sid,
  messaging_service_key,
  helproom_session_on,
  // helproom_id,
  online_hotline_on = true,
  captcha_token,
  helproom_session_data,
  webchat_language,
}) => {
  const { mutateAsync: mutateQuickExit } = useQuickExit();
  const { mutateAsync: mutateLeaveHelproom } = useLeaveHelproomSession();
  const [isExiting, setIsExiting] = useState<boolean>(false);
  const quickExit = useCallback(async () => {
    setIsExiting(true);
    removeCookies(messaging_service_key);
    const timeout = setTimeout(() => {
      window.location.replace('https://google.com');
    }, 1500);
    const promises = [];
    // To hide the conversation ended form
    SurvivorsConversationStore.userQuickExit();
    if (online_hotline_on) {
      // Set a timeout to redirect after 1.5 seconds
      promises.push(
        mutateQuickExit({
          task_sid,
          messaging_service_key,
          captcha_token: { 'g-recaptcha-response': captcha_token },
        })
      );
    }

    if (helproom_session_on && helproom_session_data) {
      promises.push(
        mutateLeaveHelproom({
          visitor_id: helproom_session_data.visitor_id,
          helproom_id: helproom_session_data.helproom_id,
          additionalHeaders: { 'g-recaptcha-response': captcha_token },
        })
      );
    }

    await Promise.all(promises);

    clearTimeout(timeout);
    window.location.replace('https://google.com');
  }, [captcha_token, helproom_session_data, helproom_session_on, messaging_service_key, mutateLeaveHelproom, mutateQuickExit, online_hotline_on, task_sid]);

  return (
    <Box className="flex justify-between items-center pb-5">
      <Box className="flex-1">
        <img className="h-7" src={logo} alt="Rainn Logo" />
        <div className="grid grid-cols-12 pt-3">
          <div className="col-span-12 lg:col-span-6">
            <p className="text-pc-1 font-bold text-2xl">{webchat_language == 'en' ? 'The National Sexual Assault Hotline' : 'La Línea de Ayuda Nacional Online de Asalto Sexual'}</p>
          </div>
          <div className="lg:col-span-6 col-span-12 flex items-center justify-end gap-3 flex-wrap">
            {/* {helproom_session_on && <FederatedHelproomGroundRules helproom_id={helproom_id} />} */}
            <Button tabIndex={0} onClick={quickExit} id="QuickExitButton" className="button-secondary button-small" disabled={isExiting}>
              {webchat_language == 'en' ? 'Quick Exit' : 'Salida rápida'}
            </Button>
            {/* {helproom_session_on && (
              <FederatedLeaveHelproomButton leave_helproom_callback={SurvivorsConversationStore.optedOutHelproom} button_class="button-secondary button-small" button_label="Exit Helproom" />
            )} */}
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default Header;

// interface FederatedLeaveHelproomButtonProps {
//   button_class: string;
//   button_label: string;
//   leave_helproom_callback: () => void;
// }

// export const FederatedLeaveHelproomButton: React.FC<FederatedLeaveHelproomButtonProps> = ({ button_class, button_label, leave_helproom_callback }) => {
//   return (
//     <Suspense fallback={<NotAvailable />}>
//       <LeaveHelproomButton leave_helproom_callback={leave_helproom_callback} button_class={button_class} button_label={button_label} />
//     </Suspense>
//   );
// };

// interface HelproomGroundRulesProps {
//   helproom_id: string | undefined;
// }

// export const FederatedHelproomGroundRules: React.FC<HelproomGroundRulesProps> = ({ helproom_id }) => {
//   return (
//     <Suspense fallback={<NotAvailable />}>
//       <HelproomGroundRules helproom_id={helproom_id} />
//     </Suspense>
//   );
// };
